import colors from "../../base/colors";
import typography from "../../base/typography";

import pxToRem from "../../functions/pxToRem";

const { inputBorderColor, primary, error, dark, grey, white } = colors;
const { size } = typography;

const inputOutlined = {
  styleOverrides: {
    root: {
      backgroundColor: white.main,
      fontSize: pxToRem(14),
      borderRadius: pxToRem(4),
      minHeight: pxToRem(32),

      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: grey[500],
      },

      "&.Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: primary.main,
          borderWidth: "2px",
        },
      },

      "&.Mui-error": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: error.main,
        },
      },

      "&.Mui-disabled": {
        backgroundColor: grey[100],
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: grey[300],
        },
      },
    },

    notchedOutline: {
      top: 0,
      borderColor: inputBorderColor,
      borderWidth: "1px",
      transition: "border-color 0.12s ease",
      "& legend": {
        display: "none",
      },
    },

    input: {
      color: dark.main,
      padding: `${pxToRem(6)} ${pxToRem(10)}`,
      backgroundColor: "transparent",
      fontSize: pxToRem(14),
      lineHeight: "20px",
      height: "auto",

      "&::placeholder": {
        color: grey[500],
        opacity: 1,
      },

      "&[type='date'], &[type='time'], &[type='datetime-local']": {
        display: "block",
        minHeight: "20px",
        lineHeight: "20px",
        colorScheme: "light",
        "&::-webkit-datetime-edit": {
          padding: 0,
          display: "inline-flex",
          alignItems: "center",
        },
        "&::-webkit-calendar-picker-indicator": {
          width: pxToRem(16),
          height: pxToRem(16),
          padding: 0,
          margin: 0,
          cursor: "pointer",
          opacity: 0.72,
        },
      },
    },

    inputSizeSmall: {
      padding: `${pxToRem(6)} ${pxToRem(10)}`,
      fontSize: pxToRem(14),
    },

    multiline: {
      color: dark.main,
      padding: `${pxToRem(6)} ${pxToRem(10)}`,
      fontSize: size.sm,
    },
  },
};

export default inputOutlined;
